"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.index-of");

require("antd/lib/typography/style");

var _typography = _interopRequireDefault(require("antd/lib/typography"));

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./TypographyText.less");

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = TypographyText;
exports.default = _default;

function TypographyText(_a) {
  var muted = _a.muted,
      primary = _a.primary,
      nowrap = _a.nowrap,
      white = _a.white,
      strong = _a.strong,
      children = _a.children,
      className = _a.className,
      rest = __rest(_a, ["muted", "primary", "nowrap", "white", "strong", "children", "className"]);

  return /*#__PURE__*/_react.default.createElement(_typography.default.Text, Object.assign({
    className: (0, _classnames.default)(className, {
      'TypographyText--type-muted': muted,
      'TypographyText--type-primary': primary,
      'TypographyText--type-nowrap': nowrap,
      'TypographyText--type-white': white,
      'TypographyText--type-strong': strong
    })
  }, rest), children);
}